// 引入常量
import { telreg, testExpress, questionSpace } from "./const.js";
// 引入element-ui
import { Message, MessageBox, Loading } from "element-ui";
import store from "../store/index";
import Vue from "vue";
let V = new Vue();

//*****公用方法******//
//生成唯一的guid(需求：请求头中全部新增客户端Id属性：属性名为x-client-id，属性值为具有唯一性的Guid)
export function setNewGuid() {
  const allConfig = sessionStorage.getItem("allConfig")
    ? JSON.parse(sessionStorage.getItem("allConfig")) || store.stste.allConfig
    : "";
  const timestamp = new Date().getTime().toString(16); // 获取当前时间戳并转换为16进制字符串
  const randomNum = Math.floor(Math.random() * 10000).toString(16); // 生成4位随机数并转换为16进制字符串
  // 获取当前时间+配置中心给的缓存时间 clientIdCacheTime分钟后的时间
  const clientIdCacheTime =
    allConfig && allConfig.clientIdCacheTime ? allConfig.clientIdCacheTime : 60;
  const futureTime = new Date(
    new Date().getTime() + clientIdCacheTime * 60 * 1000
  );
  // 转换为时间戳（单位：毫秒）
  const expirationTime = futureTime.getTime();
  const guidObj = {
    guid: timestamp + randomNum, //随机guid
    time: expirationTime, //过期时间
  };
  return JSON.stringify(guidObj);
}
// 提交文本过滤html、首尾空白
export function textFilter(str) {
  const htmlReg = /<\/?[^>]*>/g;
  str = str.replace(htmlReg, ""); //清除html标签
  str = str.replace(/[ | ]*\n/g, "\n"); //去除行尾空白
  str = str.replace(/&nbsp;/gi, ""); //去掉&nbsp;
  //str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
  //str = str.replace(/(\s|&nbsp;)+/g, '\r\n'); //将多个连续空格合并成一个空格
  //str = str.replace(/((\s|&nbsp;)*\r?\n){3,}/g, "\r\n\r\n"); //限制最多2次换行
  return str;
}
// 判断富文本编辑器输入是否为空或回车 提交文本过滤html、首尾空白
export function editorFilter(str) {
  str = str.replace(/<[^<p>]+>/g, ""); // 将所有<p>标签 replace ''
  str = str.replace(/<[</p>$]+>/g, ""); // 将所有</p>标签 replace ''
  str = str.replace(/&nbsp;/gi, ""); // 将所有 空格 replace ''
  str = str.replace(/<[^<br/>]+>/g, ""); // 将所有 换行符 replace ''
  return str;
}
// 配合上面是否为空或回车使用
export function isEditorNull(str) {
  if (str == "") return true;
  var regu = "^[ ]+$";
  var re = new RegExp(regu);
  return re.test(str);
}
// 文件格式验证
//校验上传文件格式以及文件大小(针对单个文件文件)
//参数fileObj为上传文件对象, fromat格式，size大小， name类型
//返回true为校验通过 否则为失败
function uploadVerif(fileObj, format, size, name) {
  var _name = fileObj.name;
  var _size = fileObj.size;
  if (_name == "" || _name.lastIndexOf(".") <= 0) {
    V.$message({
      message: "无效" + name + "，请重新选择上传！",
      type: "warning",
    });
    return false;
  }
  //上传文件的扩展名 转换成小写 进行验证
  var splitDot = _name.split(".");
  var fileExtension = splitDot[splitDot.length - 1].toLowerCase();
  var extensions = format;
  if (extensions.indexOf(fileExtension) < 0) {
    V.$message({
      message:
        name +
        "格式不正确！请重新上传格式为“" +
        extensions.join() +
        "”的" +
        name +
        "!",
      type: "warning",
      duration: 5000,
    });
    return false;
  }
  //上传文件大小 转换为kb 进行验证
  var _sizeKb = (parseFloat(_size) / 1024).toFixed(2); //上传的大小 单位kb
  if (_sizeKb > size * 1024) {
    V.$message({
      message: "上传" + name + "过大(不能超过" + size + "MB)，请重新选择上传！",
      type: "warning",
      duration: 4000,
    });
    return false;
  }
  return true;
}
// 图片
export function imgUploadVerif(fileObj) {
  return uploadVerif(
    fileObj,
    ["jpeg", "jpg", "bmp", "gif", "png", "bmp"],
    5,
    "图片"
  );
}
// 文件
export function fileUploadVerif(fileObj) {
  return uploadVerif(fileObj, ["doc", "docx", "xlsx", "pdf"], 10, "文件");
}

/** 格式化传入的url
 *  @newVal 传入的参数
 *  @isURIComponent 是否url解码
 *  @segmentation 以什么字符串分割
 * */
export function FormatUrlData(newVal, segmentation, isURIComponent) {
  segmentation = segmentation === undefined ? '"' : segmentation;
  isURIComponent = isURIComponent == false ? isURIComponent : true;
  if (isURIComponent) {
    try {
      // newVal = decodeURIComponent(newVal);
      newVal = newVal;
    } catch (e) {
      newVal = (newVal);
    }
  }
  // return newVal.split(segmentation).filter((o) => /^((http):)/.test(o));
  return newVal
}
// 格式化数据截取url
// 日期格式转换
// ① "-"转"/"：time = time.replace(/-/g, "/"); //safari无法识别“-”符号，转化为“/”即可
// ② "/"转"-"：time = time.replace(/\//g, '-');
// ③ 自定义格式转换，引用例子: time = timeFormat(time, 'yyyy-MM-dd hh:mm'); //格式自定义
export function timeFormat(time, fmt) {
  const dateT = time ? time.replace(/-/g, "/") : "";
  var date = new Date(dateT);
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}
// 应对后台传递的时间为：2021-12-20T14:50:37.918774
export function timeFormatNew(time, fmt) {
  var date = new Date(time);
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}

// 倒计时：日、时、分、秒
export function countdownFormat(time) {
  // var duration = Math.floor((new Date(time) - new Date()) / 1000);
  const duration = time;
  if (duration <= 0) {
    return {
      date: "00",
      hours: "00",
      minites: "00",
      seconds: "00",
    };
  } else {
    let date = Math.floor(duration / (60 * 60 * 24));
    let hours = Math.floor(duration / (60 * 60)) - date * 24;
    let minites = Math.floor(duration / 60) - date * 24 * 60 - hours * 60;
    let seconds =
      duration - date * 24 * 60 * 60 - hours * 60 * 60 - minites * 60;
    if (date < 10) {
      date = "0" + date;
    }
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minites < 10) {
      minites = "0" + minites;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return {
      date: date,
      hours: hours,
      minites: minites,
      seconds: seconds,
    };
  }
}

// 将秒数转换为时分秒格式
export function formatSeconds(value) {
  var theTime = parseInt(value); // 秒
  var minutes = 0; // 分
  var hour = 0; // 小时
  if (theTime >= 60) {
    minutes = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    if (minutes >= 60) {
      hour = parseInt(minutes / 60);
      minutes = parseInt(minutes % 60);
    }
  }
  var result = "" + parseInt(theTime) + "秒";
  if (minutes > 0) {
    result = "" + parseInt(minutes) + "分" + result;
  }
  if (hour > 0) {
    result = "" + parseInt(hour) + "小时" + result;
  }
  return result;
}

// 数组重新排序
export function sortKey(array, key) {
  //（数组，排序属性）
  return array.sort(function (a, b) {
    var x = a[key];
    var y = b[key];
    return x > y ? -1 : x < y ? 1 : 0;
  });
}

// 非空判断
export function isNull(obj) {
  if (
    obj === undefined ||
    obj === null ||
    obj === "undefined" ||
    obj === "null" ||
    obj.length === 0 ||
    obj === "00000000-0000-0000-0000-000000000000"
  ) {
    return true;
  }
  return false;
}

// html源码转纯文本
export function htmlToText(html) {
  if (!html) return;
  let result = html
    .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
    .replace(/<[^>]+?>/g, "")
    .replace(/\s+/g, " ")
    .replace(/ /g, " ")
    .replace(/>/g, " ");
  return result;
}
//按汉字截取指定字符串的长度
export function strSubString(str, len) {
  if (str.replace(/[\u4e00-\u9fa5]/g, "**").length <= len) {
    return str;
  }
  let _count = 0;
  let tmpStr = "";
  for (let i = 0; i < str.length; i++) {
    // 遍历字符串
    if (/[\u4e00-\u9fa5]/.test(str[i])) {
      // 中文 长度为两字节
      _count += 2;
    } else {
      _count += 1;
    }
    if (_count > len) {
      break;
    } else {
      tmpStr += str[i];
    }
  }
  return tmpStr;
}
//必须包含字母、数字，不限于特殊字符
const letterNumber = /^(?=.*\d)(?=.*[a-zA-Z])^[\da-zA-Z!#@?.$%^&*/]{8,16}$/;

export { letterNumber };
// 表单校验自定义规则
// 确认密码
export function validatePass2(rule, value, callback, password) {
  if (value === password) {
    callback();
  } else {
    callback(new Error("两次输入密码不一致！"));
  }
}
// 姓名
export function validateName(rule, value, callback) {
  if (testExpress.test(value)) {
    return callback(new Error("姓名只能输入中文字符！"));
  } else {
    callback();
  }
}
// 电话号码
export function validateTel(rule, value, callback) {
  if (!telreg.test(value)) {
    return callback(new Error("请输入11位数手机号码！"));
  } else {
    callback();
  }
}

// 身份类型
export function validateAdminType(rule, value, callback) {
  if (value === 0) {
    return callback(new Error("请选择身份类型！"));
  } else {
    callback();
  }
}
// 所属角色
export function validateAdminRole(rule, value, callback) {
  if (value === 0 || value === "请选择") {
    return callback(new Error("请选择所属角色！"));
  } else {
    callback();
  }
}

// 证件
export function validatecompanyCertificatesName(rule, value, callback) {
  if (value === 0) {
    return callback(new Error("请选择我方证件名称！"));
  } else {
    callback();
  }
}

export function dateformat(date, format) {
  const dateT = date ? date.replace(/-/g, "/") : "";
  if (!dateT) {
    return "";
  }
  let d = new Date(dateT);
  // 年
  if (/YYYY/.test(format)) {
    format = format.replace(/YYYY/, d.getFullYear());
  }
  // 月份
  let month = d.getMonth() + 1;
  if (/MM/.test(format)) {
    let monthStr = month < 10 ? "0" + month : month;
    format = format.replace(/MM/, monthStr);
  } else if (/M/.test(format)) {
    format = format.replace(/M/, month);
  }
  // 日期
  let dates = d.getDate();
  if (/DD/.test(format)) {
    let dateStr = dates < 10 ? "0" + dates : dates;
    format = format.replace(/DD/, dateStr);
  } else if (/D/.test(format)) {
    format = format.replace(/D/, dates);
  }
  // 小时
  let hours = d.getHours();
  if (/HH/.test(format)) {
    let hoursStr = hours < 10 ? "0" + hours : hours;
    format = format.replace(/HH/, hoursStr);
  } else if (/H/.test(format)) {
    format = format.replace(/H/, hours);
  } else if (/hh/.test(format)) {
    let hoursMin = hours > 12 ? hours - 12 : hours;
    let hoursStr = hoursMin < 10 ? "0" + hoursMin : hoursMin;
    format = format.replace(/hh/, hoursStr);
  } else if (/h/.test(format)) {
    let hoursMin = hours > 12 ? hours - 12 : hours;
    format = format.replace(/h/, hoursMin);
  }
  // 分
  let minutes = d.getMinutes();
  if (/mm/.test(format)) {
    let minutesStr = minutes < 10 ? "0" + minutes : minutes;
    format = format.replace(/mm/, minutesStr);
  } else if (/m/.test(format)) {
    format = format.replace(/m/, minutes);
  }
  // 秒
  let seconds = d.getSeconds();
  if (/ss/.test(format)) {
    let secondsStr = seconds < 10 ? "0" + seconds : seconds;
    format = format.replace(/ss/, secondsStr);
  } else if (/s/.test(format)) {
    format = format.replace(/s/, seconds);
  }
  return format;
}
// 根据管理员id获取管理员姓名
export function getAdminName(adminId) {
  let callback = "暂不知";
  let adminInfoList = sessionStorage.getItem("AdminCache")
    ? JSON.parse(sessionStorage.getItem("AdminCache")).adminInfos
    : [];
  if (adminInfoList && adminInfoList.length > 0) {
    adminInfoList.map((item) => {
      if (item.adminId == adminId) {
        callback = item.adminName;
      }
    });
  }
  return callback;
}
// 第一个时间大返回true
export function bjDate(date, date1) {
  var date = new Date(date);
  var date1 = new Date(date1);
  if (date.getTime() - date1.getTime() < 0) {
    return false;
  } else {
    return true;
  }
}

/**
 * stateSubmit方法
 * data 传入的字符串
 * isTitle 是否识别题干
 * **/
export var identifyData = {
  // 截取字符串 所有 state是否需要递归查询
  sliceText(data, text, state) {
    let index = data.indexOf(text);
    var _data;
    if (index == -1) {
      _data = data;
    } else {
      _data = data.slice(index);
    }
    if (_data.indexOf(text) != -1 && state) {
      this.sliceText(_data, text);
    } else {
      return _data;
    }
  },
  // 开始识别
  stateSubmit(data, isTitle) {
    let _data = data;
    if (!isTitle) {
      if (data.indexOf("A、") != -1) {
        _data = identifyData.sliceText(data, "A、", false);
      } else if (data.indexOf("A ") != -1) {
        _data = identifyData.sliceText(data, "A ", false);
      } else if (data.indexOf("A.") != -1) {
        _data = identifyData.sliceText(data, "A.", false);
      } else {
        _data = identifyData.sliceText(data, "A", true);
      }
    }
    // 分割字符串
    var _dataList = _data.split(identifyData.regex.upperCase);
    // 去空 去首尾空格
    _dataList = _dataList.filter((item) => item);
    _dataList = _dataList.map((element) => {
      return element.replace(/(^\s*)|(\s*$)/g, "");
    });
    // 识别题干
    if (isTitle) {
      // 需要题干
      return identifyData.pushDataTitle(_dataList);
    } else {
      // 不需要题干
      _dataList = _dataList.map((item) => {
        if (item != "A") {
          return item;
        }
      });
      _dataList = _dataList.filter((item) => item);
      return _dataList;
    }
  },
  // 需要题干的获取方法
  pushDataTitle(_dataList) {
    // 判断是否把中间大写字母分割出来了
    var length = _dataList.length;
    // 获取题干中的大写字母在数组中的下标
    var a = "";
    for (let i = length - 1; i >= 0; i--) {
      for (let j = 0; j < length; j++) {
        if (_dataList[i] == identifyData.SelectArray[j]) {
          a = i;
          break;
        }
      }
      // 有在题干中出现大写的字母a的值就不为空
      if (a != "") {
        break;
      }
    }
    var New_dataList = [];
    if (a && a > -1) {
      // 从获取数组从下标为0开始到下标位置+2 slice方法返回的不包括结束位置项所以+2
      New_dataList[0] = _dataList.slice(0, a + 2).join(" ");
      var indexNew = 1;
      for (let k = a + 2; k < _dataList.length; k++) {
        New_dataList[indexNew] = _dataList[a + 2];
        indexNew++;
      }
    } else {
      New_dataList = _dataList;
    }
    // 去首数字
    New_dataList[0] = New_dataList[0]
      .replace(identifyData.regex.number, "")
      .replace(/(^\s*)|(\s*$)/g, "");
    return New_dataList;
  },
  SelectArray: [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ],

  regex: {
    // 匹配数字
    number:
      /^\(\d+\)|^\（\d+\）|^\d+\.|^\d+ \.|^\d+\．|^\d+ \．|^\d+\)|^\d+\）|^\d+ \)|^\d+ \）|\(\d+\)$|\（\d+\）|^\d+\、|^\d+\ /g,
    // 匹配大写
    upperCase: /( [A-Z] )|(^[A-Z] )|^[A-Z]、| [A-Z]、|\n[A-Z]、|^[A-Z].| [A-Z].|\n[A-Z].|\n[A-Z]/g,
  },
};
/**
 * @rulsFormSkip 校验表单跳转方法
 */
export function rulsFormSkip(obj, list) {
  let key = obj[Object.keys(obj)[0]][0].field;
  let aaa = list.find((item) => {
    let a = item.key.find((o) => o == key);
    if (!isNull(a)) {
      return item;
    }
  });
  return (
    (Object.prototype.toString.call(aaa) == "[object Object]" && aaa.label) ||
    false
  );
}

//  校验输入框内是否输入的全是空格
export function verifyTrim(obj) {
  if (obj) {
    return obj.split(" ").join("").length == 0;
    // return obj.length > 0 && obj.trim().length != 0
  }
}
// 判断返回的HTML是否有内容
export function isHtmlContent(str) {
  str = decodeURIComponent(str);
  var data = JSON.parse(JSON.stringify(str));
  let deleteStr;
  let labelLeft = data.indexOf("<");
  let labelright = data.indexOf(">");
  if (labelLeft != -1 && labelright != -1) {
    deleteStr = data.slice(labelLeft, labelright + 1);
    data = data.replace(deleteStr, "");
    if (data.indexOf("<") != -1) {
      return isHtmlContent(data);
    } else {
      labelLeft = "";
      labelright = "";
      return data;
    }
  }
  {
    labelLeft = "";
    labelright = "";
    return data;
  }
}
//
/**
 * @ 订单状态添加类名
 * @param {String} value 匹配数组的字段
 * @param {Array} rule 匹配数组的字段
 * rule = [
 * {class:'student_tag_yellow',value:[1,2]}
 * ]
 * @param {String} class 类名
 * @param {String} value 需要改成这个类名值的集合
 */
export function addClassName(value, rule) {
  var arr = rule.find((o) => o.value.indexOf(value) != -1);
  if (arr && Object.prototype.toString.call(arr) == "[object Object]") {
    return arr.class;
  } else {
    return "student_tag_gray";
  }
}

export function isHttp(value, rule) {
  var Expression = /(http|https):\/\/([\w.]+\/?)\S*/;
  var objExp = new RegExp(Expression);
  if (objExp.test(value)) {
    return true;
  } else {
    return false;
  }
}
export function isArray(value) {
  if (
    Object.prototype.toString.call(value) == "[object Array]" &&
    value.length > 0
  ) {
    return true;
  } else {
    return false;
  }
}
export function isObject(value) {
  if (
    Object.prototype.toString.call(value) == "[object Object]" &&
    JSON.stringify(value) != "{}"
  ) {
    return true;
  } else {
    return false;
  }
}

export function TypeConversion(value) {
  var isArray = value.indexOf("[]");
}
// col背景颜色 amt浅色度 数字越小越接背景颜色
export function LightenDarkenColor(col, amt) {
  var usePound = false;
  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }
  var num = parseInt(col, 16);
  var r = (num >> 16) + amt;
  if (r > 255) r = 255;
  else if (r < 0) r = 0;
  var b = ((num >> 8) & 0x00ff) + amt;
  if (b > 255) b = 255;
  else if (b < 0) b = 0;
  var g = (num & 0x0000ff) + amt;
  if (g > 255) g = 255;
  else if (g < 0) g = 0;
  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}

export function hexToRgb(hex) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  return r + ", " + g + ", " + b;
}

export function convertToChineseNumeral(num) {
  if (num == 10) {
    return "十";
  } else if (num == 1) {
    return "一";
  }
  const digits = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  const units = ["", "十", "百", "千", "万"];
  let result = "";
  let numStr = num.toString();
  for (let i = 0; i < numStr.length; i++) {
    let digit = parseInt(numStr.charAt(i));
    let unit = units[numStr.length - i - 1];
    if (digit === 0) {
      // 当前数字为0时不需要输出汉字，但需要考虑上一个数字是否为0，避免出现连续的零
      if (result.charAt(result.length - 1) !== "零") {
        result += "零";
      }
    } else {
      result += digits[digit] + unit;
    }
  }
  // 对于一些特殊的数字，如10、100等，需要在最前面加上“一”
  if (result.charAt(0) === "一") {
    result = result.substr(1, result.length);
  } else if (result.charAt(0) === "百") {
    result = "一" + result;
  } else if (result.charAt(0) === "千") {
    result = "一" + result;
  }
  return result;
}
//中国标准时间转化成标准时间
export function convertCSTtoUTC(cstString) {
  // 将 CST 字符串转为 Date 对象
  var cstDate = new Date(cstString);
  // 将 CST 时间减去 8 小时得到 UTC 时间
  var utcDate = new Date(cstDate.getTime() - 8 * 3600 * 1000);
  // 返回格式化后的 UTC 时间字符串
  return utcDate.toISOString(); // 输出格式类似于 "2023-04-27T01:30:00.000Z"
}

export const _Paste = (e) => {
  // 如果剪贴板没有数据则直接返回
  if (!(e.clipboardData && e.clipboardData.items)) {
    return
  }
  if (e.clipboardData.items.length > 1) {
    return
  }
  // 用Promise封装便于将来使用
  return new Promise((resolve, reject) => {
    // 复制的内容在剪贴板里位置不确定，所以通过遍历来保证数据准确
    for (let i = 0, len = e.clipboardData.items.length; i < len; i++) {
      const item = e.clipboardData.items[i]
      // 文本格式内容处理
      if (item.kind === 'string') {
        item.getAsString((str) => {
          // TODO(str) 为获取到的字符串
          // resolve(str)
          reject(new Error('请粘贴图片')) // 根据业务不允许粘贴文字
        })
        // 图片格式内容处理
      } else if (item.kind === 'file') {
        const pasteFile = item.getAsFile()
        // 处理pasteFile
        resolve(pasteFile)
      } else {
        reject(new Error('Not allow to paste this type!'))
      }
    }
  })
}

// el-form校验失败滚动到对应的错误位置
export function elFormErrorScrollIntoView() {
  // 获取第一个校验错误的元素
  const element = document.querySelectorAll('.el-form-item__error')[0]
  // 滚动到错误元素对应位置
  element.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  })
}
// 判断当前浏览器
export function isNumberBrowser(){
  
  // let arr =  navigator.userAgent.split(" ")
  // let lastStr = arr[arr.length - 1]
  // （谷歌和360浏览器）的判断
  // if (lastStr.indexOf('Safari') != -1) {
  if (navigator.userAgent.toLowerCase().includes('wow64')) {
    return '360'
  } else {
    let name = isNumberBrowser2()
    return name
  }
  // }
  // 其他浏览器返回空，后端会获取userAgent

}
// 谷歌和360浏览器
function isNumberBrowser2(){
  let is360 = false
  for (var key in navigator.plugins) {
    if (navigator.plugins[key].filename == 'np-mswmp.dll') {
      is360 = true
    }
  }

  if(is360){
    return '360'
  }else{
    let flag = isNumberBrowser3("type", "application/vnd.chromium.remoting-viewer")
    if(flag){
      return '360'
    }else{
      return ''
    }
    
  }

}
// 谷歌和360浏览器2
function isNumberBrowser3(option, value) {
  let mimeTypes = navigator.mimeTypes;
  for (var mt in mimeTypes) {
    if (mimeTypes[mt][option] == value) {
      return true;
    }
  }
  return false;
}
// 判断当前浏览器
export function nameBrowser(){
  let browseName = ''
  // （360浏览器）的判断
  if (navigator.userAgent.toLowerCase().includes('wow64')) {
    browseName =  '360'
  } else {
    browseName = isNumberBrowser2()
  }
  if(browseName){
    return browseName
  }

  // Chrome
  let arr =  navigator.userAgent.split(" ")
 
  if(navigator.userAgent.indexOf("Chrome")!== -1 && navigator.userAgent.indexOf("Safari") !== -1 && arr[arr.length - 1].indexOf("Safari") !== -1){
    return arr.filter(item => item.indexOf("Chrome") != -1)[0]
  }
  // 其他浏览器输出 最后一项
  return arr[arr.length - 1]

}
// 试题题干空格判断
export function validateTitle(rule, value, callback,data,message,pType) {
  if(!data){
    // 非空判断
    return callback(new Error(`请输入试题题干`));
  }else{
    // 有值判断
    if(pType===3&&checkUrls(data).length==0){
      return callback(new Error(`请添加填空空格`));
    }else{
      callback();
    }
  }
}
// 校验富文本内容（字符串）是否有试题空格图片
function extractImageUrls(str) {
  const imgTagRegex = /<img[^>]+src="([^">]+)"/g;
  let matches;
  const urls = [];

  while ((matches = imgTagRegex.exec(str)) !== null) {
      urls.push(matches[1]);
  }

  return urls;
}
export function checkUrls(string) {
  const imageUrls = extractImageUrls(string);
  const commonUrls = imageUrls.filter(url => questionSpace.includes(url));
  return commonUrls;
};
export function replaceImageSrcWithArray(string) {
  let currentIndex = 0;
  return string.replace(/<img[^>]+src="([^">]+)"/g, function(match, p1) {
    console.log(match,'match')
      let newSrc = p1;
      // 只在当前src已经在urlArray中的情况下进行替换
      if (questionSpace.includes(p1) && currentIndex < questionSpace.length) {
          newSrc = questionSpace[currentIndex];
          currentIndex++;
      }
      return match.replace(p1, newSrc);
  });
}

/**
 * 从函数调用字符串中获取参数列表
 * @param {*} functionInvocation 
 * @returns {null | Array<any>}
 * 
 * @example
 * ```js
 * getParameters("test('hello', 1)")  // ['hello', 1]
 * ```
 */
export function getParameters(functionInvocation) {
  const regExp = /\((.*?)\)/;
  const match = regExp.exec(functionInvocation);
  let params = []
  if (match && match[1]) {
    params = match[1].split(',').map(param => param.trim());
    return params;
  }
  return params; 
}
/**
 * 从函数调用字符串中获取函数名
 * @param {*} functionInvocation 
 * @returns {null | string}
 * 
 * @example
 * ```js
 * getFunctionName("test('hello', 1)")  // test
 * ```
 */
export function getFunctionName(functionInvocation) {
  const regExp = /^([a-zA-Z_$][a-zA-Z0-9_$]*)\s*\(/;
  const match = regExp.exec(functionInvocation);
  if (match && match[1]) {
    return match[1]; 
  }
  // 在没有匹配到括号的情况下，视整个字符串为函数名
  return functionInvocation; 
}
